import React, { useContext } from "react";
import { useSelector } from "react-redux";
import { ValidSuccesArrow } from "Res/icons";
import DomainContext from "Context/DomainContext";
import { SkeletonLine } from "Components/Skeletion";

function UpsContent() {
  const { cartDetails } = useSelector((state) => ({
    cartDetails: state?.cartItems?.[0],
  }));

  const { storeId } = useContext(DomainContext);

  const upsItems = cartDetails?.ups_feature_content?.[0];
  const hasContent = cartDetails?.totals_detail?.items?.length || !upsItems?.length;

  return (
    <div className={`static__content ${hasContent ? "pt-8" : ""}`}>
      <h3 className="fw-700 fs-18">
        Daarom {storeId === 1 ? "Promofit" : storeId === 2 ? "Expofit" : ""}!
      </h3>

      <div className="ups__content flex col gap-3 pt-4">
        {upsItems ? (
          upsItems.map((item, index) => (
            <div className="flex middle space-between" key={index}>
              <div className="flex middle gap-3 lg-gap-2">
                <ValidSuccesArrow role="presentation" />
                <span className="fs-15 line-6">{item?.menu?.title}</span>
              </div>
            </div>
          ))
        ) : (
          Array.from({ length: 4 }).map((_, index) => (
            <div className="mb-2" key={index}>
              <SkeletonLine width="100%" height="30px" />
            </div>
          ))
        )}
      </div>
    </div>
  );
}

export default UpsContent;
